<div (click)="back()" class="button">
    <i class="color-white fa-solid fa-chevron-left fa-xl"></i>
</div>
